import { teacherMessages } from './en-US';

export const programId = '5f2082b0cb127b1b24a3822a';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },

    logLevel: 'error',
    messagesWithLocale: {
        'en-US': teacherMessages,
    },
    urlTeacherFaq: 'https://verify.sheerid.com/headspace-intl-teacher-faq/',
};
